export const state = {
  showCustomerSuggestion: true,
  loggingOut: false,
  province: '',
  municipality: '',
  customerStatus: 'All'
}

export const getters = {
  showCustomerSuggestionState: state => state.showCustomerSuggestion,
  isUserLoggingOutState: state => state.loggingOut,
  customerProvinceState: state => state.province,
  customerMunicipalityState: state => state.municipality,
  customerStatusState: state => state.customerStatus
}

export const mutations = {
  showCustomerSuggestionCommit (state, showCustomerSuggestion) {
    state.showCustomerSuggestion = showCustomerSuggestion
  },

  isUserLoggingOutCommit (state, loggingOut) {
    state.loggingOut = loggingOut
  },

  customerProvinceCommit (state, province) {
    state.province = province
  },

  customerMunicipalityCommit (state, municipality) {
    state.municipality = municipality
  },

  customerStatusCommit (state, customerStatus) {
    state.customerStatus = customerStatus
  }
}

export const actions = {
  async showCustomerSuggestionAction ({ commit }, showCustomerSuggestion) {
    commit('showCustomerSuggestionCommit', showCustomerSuggestion)
  },

  async isUserLoggingOutAction ({ commit }, isUserLoggingOut) {
    commit('isUserLoggingOutCommit', isUserLoggingOut)
  },

  async customerProvinceAction ({ commit }, province) {
    commit('customerProvinceCommit', province)
  },

  async customerMunicipalityAction ({ commit }, municipality) {
    commit('customerMunicipalityCommit', municipality)
  },

  async customerStatusAction ({ commit }, customerStatus) {
    commit('customerStatusCommit', customerStatus)
  }
}
